import React, { useRef, useState } from 'react'
import trans from '~/translations/trans'
import { Filter } from '~/service/TicketListManager'
import { DatePicker as DatePick } from 'antd'

type DatePickerProps = {
  filter: Filter
  setFilter: React.Dispatch<React.SetStateAction<Filter>>
}

const DatePicker: React.FC<DatePickerProps> = ({ filter, setFilter }) => {
  const { RangePicker } = DatePick

  return (
    <>
      <div className="field">
        <RangePicker
          showTime
          className="input is-rounded"
          format="YYYY-MM-DD"
          placeholder={[trans.date.from(), trans.date.to()]}
          onChange={(date, dateString) =>
            setFilter({
              ...filter,
              dateFrom: dateString[0],
              dateTo: dateString[1],
            })
          }
        />
      </div>
    </>
  )
}

export default DatePicker
